import { useEffect, useState } from 'react';

// Tailwind's `lg`. Below it the app is the mobile pass — a dialog is the whole
// screen and a phone's own display rendition already out-resolves it; above it
// there is room for detail a 2800px rendition can't supply.
const DESKTOP_QUERY = '(min-width: 1024px)';

/**
 * Whether the viewport is desktop-sized, kept current as the window resizes.
 *
 * This is for behaviour that can't be expressed in CSS — a fetch that should
 * only happen on a large screen. Anything that is only a matter of layout
 * belongs in a Tailwind breakpoint instead, where it costs no render.
 */
export function useIsDesktop(): boolean {
  const [isDesktop, setIsDesktop] = useState(() => window.matchMedia(DESKTOP_QUERY).matches);

  useEffect(() => {
    const query = window.matchMedia(DESKTOP_QUERY);
    const onChange = (event: MediaQueryListEvent) => setIsDesktop(event.matches);
    query.addEventListener('change', onChange);
    return () => query.removeEventListener('change', onChange);
  }, []);

  return isDesktop;
}
